import React, { createContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import { Box, Button, Stack, useMediaQuery } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import InvirteLogoComponent from "./InvirteLogo";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PersonIcon from "@mui/icons-material/Person";
import { useTheme } from "@emotion/react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const SidebarLink = ({ to, currentPath, text, logout = false, icon }) => (
  <Button
    component={Link}
    to={to}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
      gap: ".5em",
      // position: logout ? "absolute" : "block",
      // bottom: logout ? 50 : "initial",
      p: 0,
      px: 2,
      py: 1,
      borderRadius: 2,
      mb: 2,
      textTransform: "capitalize",
      color: currentPath === to ? "primary.main" : "#BDDDFA",
      backgroundColor: currentPath === to ? "#BDDDFA" : "primary.main",
      "&:hover": {
        color: currentPath === to ? "primary.main" : "#BDDDFA",
        backgroundColor: currentPath === to ? "#BDDDFA" : "primary.main",
      },
    }}
  >
    {icon}
    <Typography>{text}</Typography>
  </Button>
);

const DrawerAdmin = ({ openMenu, toggleMenu }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (openMenu) {
      toggleMenu();
    }
  }, [pathname]);

  return (
    <Drawer
      open={openMenu}
      onClose={toggleMenu}
      anchor="left"
      sx={{
        width: "400px",
        display: { xs: "initial", lg: "none" },
      }}
    >
      <Stack
        sx={{
          px: 2,
          py: 1,
          width: 270,
          height: "100vh", // Asegura que el Stack ocupe toda la altura
          backgroundColor: "primary.main",
          color: "white",
          position: "fixed", // Necesario para posicionar el botón de cerrar sesión fijo
          overflow: "auto",
        }}
      >
        <Stack spacing={1} height="100vh" justifyContent="space-between">
          {/* Logo */}
          <Stack textAlign="center" mb={4} pl={2} pt={2}>
            <InvirteLogoComponent width={{ xs: 90, md: 100, lg: 110 }} />
          </Stack>

          {/* Opciones del menú */}

          <Stack>
            <SidebarLink
              to="/dashboard"
              currentPath={pathname}
              text={"Dashboard"}
              icon={<SpaceDashboardIcon />}
            />
            <SidebarLink
              to="/dashboard/create/property"
              currentPath={pathname}
              text={"Crear Inmueble"}
              icon={<MapsHomeWorkIcon />}
            />
            <SidebarLink
              to="/dashboard/property/accepted"
              currentPath={pathname}
              text={"Inmuebles"}
              icon={<MapsHomeWorkIcon />}
            />
            <SidebarLink
              to="/dashboard/property/sold"
              currentPath={pathname}
              text={"Inmuebles Vendidos"}
              icon={<MapsHomeWorkIcon />}
            />
            <SidebarLink
              to="/dashboard/property/rented"
              currentPath={pathname}
              text={"Inmuebles Arrendados"}
              icon={<MapsHomeWorkIcon />}
            />
            <SidebarLink
              to="/dashboard/property/interest"
              currentPath={pathname}
              text={"Interesados inmuebles"}
              icon={<PersonIcon />}
            />
            <SidebarLink
              to="/dashboard/property/contacted"
              currentPath={pathname}
              text={"Interesados contactados"}
              icon={<PersonIcon />}
            />
            <SidebarLink
              to="/dashboard/projects/accepted"
              currentPath={pathname}
              text={"Proyectos Aceptados"}
              icon={<AutoGraphIcon />}
            />
            <SidebarLink
              to="/dashboard/projects/pending"
              currentPath={pathname}
              text={"Proyectos Pendientes"}
              icon={<AutoGraphIcon />}
            />
            <SidebarLink
              to="/dashboard/projects/rejected"
              currentPath={pathname}
              text={"Proyectos Rechazados"}
              icon={<AutoGraphIcon />}
            />
            <SidebarLink
              to="/dashboard/investments/accepted"
              currentPath={pathname}
              text={"Inversiones aceptadas"}
              icon={<BusinessCenterIcon />}
            />
            <SidebarLink
              to="/dashboard/investments/pending"
              currentPath={pathname}
              text={"Inversiones Pendientes"}
              icon={<BusinessCenterIcon />}
            />
            <SidebarLink
              to="/dashboard/investments/rejected"
              currentPath={pathname}
              text={"Inversiones Rechazadas"}
              icon={<BusinessCenterIcon />}
            />
          </Stack>
          <Stack>
            <SidebarLink
              to="/logout"
              currentPath={pathname}
              text={"Cerrar sesión"}
              logout={true}
              icon={<LogoutIcon />}
            />
          </Stack>
        </Stack>
      </Stack>
    </Drawer>
  );
};

function HeaderAdmin() {
  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };
  const theme = useTheme();

  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const path = useLocation();
  return (
    <>
      {isLargeScreen &&
        (path.pathname.startsWith("/dashboard/manage/project/") ||
          path.pathname.startsWith("/dashboard/preview/project/") ||
          path.pathname.startsWith("/dashboard/manage/property/")) ? (
        <AppBar
          position="sticky"
          color="primary"
          sx={{ display: "flex", top: 0, py: 1 }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              sx={{ color: "white", mr: 1 }}
              aria-label="menu"
              onClick={() => {
                window.history.back();
              }}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
            <InvirteLogoComponent width={110} />
          </Toolbar>
        </AppBar>
      ) : (
        <AppBar
          position="sticky"
          color="primary"
          sx={{ display: { xs: "flex", lg: "none" }, top: 0, py: 0.5 }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              sx={{ color: "white", mr: 1 }}
              aria-label="menu"
              onClick={toggleMenu}
            >
              <Menu />
            </IconButton>
            <InvirteLogoComponent />
          </Toolbar>
        </AppBar>
      )}
      <DrawerAdmin openMenu={openMenu} toggleMenu={toggleMenu} />
    </>
  );
}

export default HeaderAdmin;
